import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getDashboardPathForRole } from "../utils/tokenUtils";

const PublicRoute = ({ element }) => {
  const { user } = useAuth();
  const [redirectPath, setRedirectPath] = useState(null);
  const location = useLocation();
  useEffect(() => {
    if (user) {
      const dashboardPath = getDashboardPathForRole(user.role);
      setRedirectPath(dashboardPath);
    }
  }, [user]);
  if (redirectPath) {
    return <Navigate to={redirectPath} state={{ from: location }} />;
  }

  return element;
};

export default PublicRoute;
